import React,{ Component } from "react";
import { connect } from "react-redux";
import { getSignOnURL, set_saml_config, get_saml_config, update_saml_config } from "../../../actions/actionSaml";
import { Field, reduxForm } from "redux-form";
import { Row, Col, Label, Button, Modal, ModalHeader, Input, InputGroup, InputGroupAddon, Form,
    FormGroup, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader, CardFooter, Alert, Container } from "reactstrap";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router-dom";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import {renderCheckbox, renderField, renderTextArea, required} from "../../../utils/formValidations";
import BreadCrumbCompo from "../../../components/Breadcrumb";
import { getLicenseStatus} from "../../../actions/actionFooter";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Saml",path:"/saml",isActive: true}
];

class UpdateSaml extends Component{
    constructor(props){
        super(props);
        this.state = {
            saml_id: 0,
            relayState: "https://" + window.location.host + "/#/sso",
            licensed: false,
        };
        this.copyToClipboard = this.copyToClipboard.bind(this);
        this.getURL = this.getURL.bind(this);
        this.getMetadata = this.getMetadata.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.initialize = this.initialize.bind(this);
        this.submitError = this.submitError.bind(this);
        this.submitSuccess = this.submitSuccess.bind(this);
        this.handleSSOSuccess = this.handleSSOSuccess.bind(this);
        this.handleSSOError = this.handleSSOError.bind(this);
    }

    copyToClipboard(text) {
        const el = document.createElement('textarea');
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    componentDidMount() {
        this.setState({
            saml_id: this.props.match.params.id
        });
        this.initialize();
        this.props.getLicenseStatus()
            .then(() => {
                const {license_info} = this.props;
                if (license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('saml') >= 0 ){
                    this.setState({licensed: true});
                }
            });
    }

    initialize() {
        this.props.get_saml(this.props.match.params.id)
            .then(() => {
                this.props.initialize({
                    display_name: this.props.saml_config.display_name,
                    hostname: this.props.saml_config.hostname,
                    is_default: this.props.saml_config.is_default,
                    debug: this.props.saml_config.debug,
                    auto_login: this.props.saml_config.auto_login,
                    sp_entity_id: this.props.saml_config.sp_entity_id,
                    sp_acs_url: this.props.saml_config.sp_acs_url,
                    adfs: this.props.saml_config.adfs,
                    enabled: this.props.saml_config.enabled,
                    sp_slo_url: this.props.saml_config.sp_slo_url,
                    group_attribute: this.props.saml_config.group_attribute,
                    sp_name_id: this.props.saml_config.sp_name_id,
                    sp_x509_cert: this.props.saml_config.sp_x509_cert,
                    sp_private_key: this.props.saml_config.sp_private_key,
                    idp_entity_id: this.props.saml_config.idp_entity_id,
                    idp_sso_url: this.props.saml_config.idp_sso_url,
                    idp_slo_url: this.props.saml_config.idp_slo_url,
                    idp_x509_cert: this.props.saml_config.idp_x509_cert,
                    want_attribute_statement: this.props.saml_config.want_attribute_statement,
                    name_id_encrypted: this.props.saml_config.name_id_encrypted,
                    authn_request_signed: this.props.saml_config.authn_request_signed,
                    logout_request_signed: this.props.saml_config.logout_request_signed,
                    logout_response_signed: this.props.saml_config.logout_response_signed,
                    sign_metadata: this.props.saml_config.sign_metadata,
                    want_messages_signed: this.props.saml_config.want_messages_signed,
                    want_assertions_signed: this.props.saml_config.want_assertions_signed,
                    want_name_id: this.props.saml_config.want_name_id,
                    want_name_id_encrypted: this.props.saml_config.want_name_id_encrypted,
                    want_assertions_encrypted: this.props.saml_config.want_assertions_encrypted,
                    signature_algorithm: this.props.saml_config.signature_algorithm,
                    digest_algorithm: this.props.saml_config.digest_algorithm
                });
            })
    }

    submitForm(formData){
        formData.saml_id = this.props.saml_config.saml_id;
        this.props.update_saml(formData)
        .then(() => this.submitSuccess())
        .catch(() => this.submitError());
    }

    submitSuccess() {
        const {update_saml_error_message} = this.props;
        if (update_saml_error_message){
            NotificationManager.error(update_saml_error_message,"Saml Update", 5000);
        } else {
            this.initialize();
            NotificationManager.success("Saml Configuration Updated", "Saml Update", 5000);
            this.props.history.push("/saml");
        }
    }

    submitError() {
        NotificationManager.error("Configuration Update Failed","Saml Update", 5000);
    }

    getURL(){
        this.props.getsso(this.props.match.params.id)
            .then(() => this.handleSSOSuccess())
            .catch(() => this.handleSSOError());
    }

    handleSSOSuccess() {
        const {sso_url, sso_error_message} = this.props;
        if (sso_error_message) {
            NotificationManager.error(sso_error_message,"Login Failed", 5000);
        } else {
            if (sso_url) {
                NotificationManager.success("Login Success", 5000);
                window.location.href = sso_url;
            }
        }
    }

    handleSSOError(){
        const {sso_error} = this.props;
        if (sso_error)
            NotificationManager.error(this.props.sso_error,"Login Failed", 5000);
    }

    getMetadata(){
        window.open(this.props.saml_config.sp_entity_id);
    }

    render(){
        const {handleSubmit} = this.props;
        const {relayState } = this.state;
        const checked = this.props.saml_config.enabled;
        const isDefault = this.props.saml_config.is_default;
        const checkedADFS = this.props.saml_config.adfs;
         if (!this.state.licensed){
            let license_url = `${__LICENSE_INFO_URL__}`;
            return (
                <div>
                    <BreadCrumbCompo routes={routes}/>
                    <Row>
                        <Container>
                            <Col sm={{size: 8, order: 3, offset: 2}}>
                                <Card className = "user-form-container">
                                    <CardHeader>
                                        <strong>SAML 2.0 Configurations</strong>
                                    </CardHeader>
                                    <Alert color="none" isOpen={true}>
                                        <h4>Unavailable</h4>
                                        This feature must be licensed.
                                        <hr />
                                        <a href={license_url}>More Information</a><br/>
                                    </Alert>
                                </Card>
                            </Col>
                        </Container>
                    </Row>
                </div>

            )
        }
        return (
            <div >
                <BreadCrumbCompo routes={routes}/>
                <Form className="p-3" onSubmit={handleSubmit(this.submitForm)}>
                <Row>
                    <Col sm={11} >
                        <Card className = "user-form-container">
                            <CardHeader>
                                <strong>SAML 2.0 Configurations</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={6} >
                                        <h4>Service Provider</h4>
                                        <FormGroup>
                                            <Row>
                                                <Col>
                                                    <Label>Enabled</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Label>
                                                        <Field name="enabled"
                                                               id="enabled"
                                                               type ="checkbox"
                                                               checked = {checked}
                                                               component={renderCheckbox}
                                                        />
                                                    </Label>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="3">
                                                    <Label >Display Name</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="display_name"
                                                           id="display_name"
                                                           component={renderField}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>

                                        <FormGroup>
                                            <Row>
                                                <Col sm="3">
                                                    <Label >Host Name</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="hostname"
                                                           id="hostname"
                                                           validate={required}
                                                           component={renderField}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>

                                        <FormGroup>
                                            <Row>
                                                <Col  sm="3">
                                                    <Label >Entity ID:</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col style={{'padding-right': '0px'}} >
                                                    <Field type="text"
                                                           name="sp_entity_id"
                                                           id="sp_entity_id"
                                                           component={renderField}
                                                    />
                                                </Col>
                                                <Col style={{'padding-left': '0px'}} sm={1}>
                                                    <Button
                                                        onClick={() => this.copyToClipboard(this.props.saml_config.sp_entity_id)}>
                                                        <i className = "fa fa-copy" aria-hidden="true"></i>
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </FormGroup>

                                        <FormGroup>
                                            <Row>
                                                <Col sm="5">
                                                    <Label >Single Sign On Service:</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col style={{'padding-right': '0px'}}>
                                                    <Field type="text"
                                                           name="sp_acs_url"
                                                           id="sp_acs_url"
                                                           component={renderField}
                                                    />
                                                </Col>
                                                <Col style={{'padding-left': '0px'}} sm={1}>
                                                    <Button
                                                        onClick={() => this.copyToClipboard(this.props.saml_config.sp_acs_url)}>
                                                        <i className = "fa fa-copy" aria-hidden="true"></i>
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </FormGroup>

                                        <FormGroup>
                                            <Row>
                                                <Col sm="3">
                                                    <Label >Single Logout Service:</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col style={{'padding-right': '0px'}} >
                                                    <Field type="text"
                                                           name="sp_slo_url"
                                                           id="sp_slo_url"
                                                           component={renderField}
                                                    />
                                                </Col>
                                                <Col style={{'padding-left': '0px'}} sm={1}>
                                                    <Button
                                                        onClick={() => this.copyToClipboard(this.props.saml_config.sp_slo_url)}>
                                                        <i className = "fa fa-copy" aria-hidden="true"></i>
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </FormGroup>

                                        <FormGroup>
                                            <Row>
                                                <Col sm="5">
                                                    <Label>Relay State:</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <InputGroup>
                                                        <Input
                                                            readOnly
                                                            value={relayState} />
                                                        <InputGroupAddon addonType="append">
                                                            <Button
                                                                onClick={() => this.copyToClipboard(relayState)}>
                                                                <i className = "fa fa-copy" aria-hidden="true"></i>
                                                            </Button>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <hr />
                                        <FormGroup>
                                            <Row>
                                                <Col>
                                                    <Label>Default</Label>
                                                </Col>

                                                <Col>
                                                    <Label>Auto Login</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Label>
                                                        <Field name="is_default"
                                                               id="default"
                                                               type ="checkbox"
                                                               checked = {isDefault}
                                                               component={renderCheckbox}
                                                        />
                                                    </Label>
                                                </Col>
                                                <Col>
                                                    <Label>
                                                        <Field name="auto_login"
                                                               id="auto_login"
                                                               type ="checkbox"
                                                               checked = {checked}
                                                               component={renderCheckbox}
                                                        />
                                                    </Label>
                                                </Col>
                                            </Row>
                                        </FormGroup>

                                        <FormGroup>
                                            <Row>
                                                <Col sm="3">
                                                    <Label >Group Member Attribute</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="group_attribute"
                                                           id="group_attribute"
                                                           component={renderField}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="3">
                                                    <Label >NameID Attribute</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="sp_name_id"
                                                           id="sp_name_id"
                                                           component={renderField}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="3">
                                                    <Label>X509 Certificate</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="sp_x509_cert"
                                                           id="sp_x509_cert"
                                                           component={renderTextArea}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="3">
                                                    <Label>Private Key</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="sp_private_key"
                                                           id="sp_private_key"
                                                           component={renderTextArea}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col>
                                                    <Label>Debug</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Label>
                                                        <Field name="debug"
                                                               id="debug"
                                                               type ="checkbox"
                                                               checked = {checked}
                                                               component={renderCheckbox}
                                                        />
                                                    </Label>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <h4>Identity Provider</h4>
                                        <FormGroup>
                                            <Row>
                                                <Col>
                                                    <Label>ADFS (Active Directory Federated Services)</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Label>
                                                        <Field name="adfs"
                                                               id="adfs"
                                                               type ="checkbox"
                                                               checked = {checkedADFS}
                                                               component={renderCheckbox}
                                                        />
                                                    </Label>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="3">
                                                    <Label className="requiredasterisk">Entity ID</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="idp_entity_id"
                                                           id="idp_entity_id"
                                                           component={renderField}
                                                           validate={required}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label className="requiredasterisk">Single Sign On Service/SAML 2.0 Endpoint:</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="idp_sso_url"
                                                           id="idp_sso_url"
                                                           component={renderField}
                                                           validate={required}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label >Single Logout Service/SLO Endpoint:</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="idp_slo_url"
                                                           id="idp_slo_url"
                                                           component={renderField}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="3">
                                                    <Label >X509 Certificate</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="idp_x509_cert"
                                                           id="idp_x509_cert"
                                                           component={renderTextArea}
                                                           validate={required}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <hr />
                                        <h4>Advanced Settings</h4>
                                        <Row>
                                            <Col>
                                                <FormGroup>
                                                    <Row>
                                                        <Col>
                                                            <Label>Want Attribute Statement</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Label>
                                                                <Field name="want_attribute_statement"
                                                                       id="want_attribute_statement"
                                                                       type ="checkbox"
                                                                       checked = {checked}
                                                                       component={renderCheckbox}
                                                                />
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col>
                                                            <Label>Name ID Encrypted</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Label>
                                                                <Field name="name_id_encrypted"
                                                                       id="name_id_encrypted"
                                                                       type ="checkbox"
                                                                       checked = {checked}
                                                                       component={renderCheckbox}
                                                                />
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col>
                                                            <Label>Authn Requests Signed</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Label>
                                                                <Field name="authn_request_signed"
                                                                       id="authn_request_signed"
                                                                       type ="checkbox"
                                                                       checked = {checked}
                                                                       component={renderCheckbox}
                                                                />
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col>
                                                            <Label>Logout Request Signed</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Label>
                                                                <Field name="logout_request_signed"
                                                                       id="logout_request_signed"
                                                                       type ="checkbox"
                                                                       checked = {checked}
                                                                       component={renderCheckbox}
                                                                />
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col>
                                                            <Label>Logout Response Signed</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Label>
                                                                <Field name="logout_response_signed"
                                                                       id="logout_response_signed"
                                                                       type ="checkbox"
                                                                       checked = {checked}
                                                                       component={renderCheckbox}
                                                                />
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col>
                                                            <Label>Sign Metadata</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Label>
                                                                <Field name="sign_metadata"
                                                                       id="sign_metadata"
                                                                       type ="checkbox"
                                                                       checked = {checked}
                                                                       component={renderCheckbox}
                                                                />
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Row>
                                                        <Col>
                                                            <Label>Want Messages Signed</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Label>
                                                                <Field name="want_messages_signed"
                                                                       id="want_messages_signed"
                                                                       type ="checkbox"
                                                                       checked = {checked}
                                                                       component={renderCheckbox}
                                                                />
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col>
                                                            <Label>Want Assertions Signed</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Label>
                                                                <Field name="want_assertions_signed"
                                                                       id="want_assertions_signed"
                                                                       type ="checkbox"
                                                                       checked = {checked}
                                                                       component={renderCheckbox}
                                                                />
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col>
                                                            <Label>Want Name ID</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Label>
                                                                <Field name="want_name_id"
                                                                       id="want_name_id"
                                                                       type ="checkbox"
                                                                       checked = {checked}
                                                                       component={renderCheckbox}
                                                                />
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col>
                                                            <Label>Want Encrypted Name ID </Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Label>
                                                                <Field name="want_name_id_encrypted"
                                                                       id="want_name_id_encrypted"
                                                                       type ="checkbox"
                                                                       checked = {checked}
                                                                       component={renderCheckbox}
                                                                />
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col>
                                                            <Label>Want Encrypted Assertions</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Label>
                                                                <Field name="want_assertions_encrypted"
                                                                       id="want_assertions_encrypted"
                                                                       type ="checkbox"
                                                                       checked = {checked}
                                                                       component={renderCheckbox}
                                                                />
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="5">
                                                    <Label >Signature Algorithm:</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col >

                                                    <Field name="signature_algorithm"
                                                           id="signature_algorithm"
                                                           component="select"
                                                    >
                                                        <option>http://www.w3.org/2000/09/xmldsig#rsa-sha1</option>
                                                        <option>http://www.w3.org/2000/09/xmldsig#dsa-sha1</option>
                                                        <option>http://www.w3.org/2001/04/xmldsig-more#rsa-sha256</option>
                                                        <option>http://www.w3.org/2001/04/xmldsig-more#rsa-sha384</option>
                                                        <option>http://www.w3.org/2001/04/xmldsig-more#rsa-sha512</option>
                                                    </Field>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="5">
                                                    <Label >Digest Algorithm:</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col >
                                                    <Field name="digest_algorithm"
                                                           id="digest_algorithm"
                                                           component="select"
                                                    >
                                                        <option>http://www.w3.org/2000/09/xmldsig#sha1</option>
                                                        <option>http://www.w3.org/2001/04/xmlenc#sha256</option>
                                                        <option>http://www.w3.org/2001/04/xmldsig-more#sha384</option>
                                                        <option>http://www.w3.org/2001/04/xmlenc#sha512</option>
                                                    </Field>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                            <CardFooter>
                                <FormGroup className="form-actions">
                                    <Button type="submit" size="sm" 
                                    className="submit-button" 
                                    color="primary">Submit</Button>
                                    <Button size="sm" color="primary"
                                    className="submit-button" 
                                    onClick={this.getURL}>Test SSO</Button>
                                    <Button size="sm" 
                                    className="submit-button" 
                                    color="primary" onClick={this.getMetadata}>Get MetaData</Button>
                                </FormGroup>
                            </CardFooter>

                        </Card>
                    </Col>

                </Row>
            </Form>

            </div>
        );
    }
}

UpdateSaml.propTypes = {
    saml_requests: Proptypes.array,
    handleSubmit: Proptypes.func,
};

let  SamlFormWithRouter = withRouter(UpdateSaml);

let SamlForm = connect(state => ({
        saml_request: state.saml || [],
        saml_config: state.saml.saml_config || [],
        set_saml_error: state.saml.set_saml_error || [],
        get_saml_error: state.saml.get_saml_error || [],
        update_saml_error_message: state.saml.update_saml_error_message,
        sso_url: state.saml.sso_url,
        sso_saml_error: state.saml.sso_saml_error,
        sso_error: state.saml.sso_error,
        license_info: state.footer && state.footer.license_info ? state.footer.license_info : null,
    }),
    dispatch => ({
        getsso: (id) => dispatch(getSignOnURL(id)),
        set_saml: (formData) => dispatch(set_saml_config(formData)),
        update_saml: (formData) => dispatch(update_saml_config(formData)),
        get_saml: (data) => dispatch(get_saml_config(data)),
        getLicenseStatus: () => dispatch(getLicenseStatus()),
    }))(SamlFormWithRouter);

export default reduxForm({
    form: "samlForm",
})(SamlForm);


// WEBPACK FOOTER //
// ./src/views/Saml/UpdateSaml/UpdateSaml.js